import script from "./IconCall.vue?vue&type=script&setup=true&lang=js"
export * from "./IconCall.vue?vue&type=script&setup=true&lang=js"

import "./IconCall.vue?vue&type=style&index=0&id=5bf09a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bf09a48"]])

export default __exports__